import {FC, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import moment from 'moment'
import {SchedulerModel} from '../models/SchedulerModel'
import {DATE_FORMAT} from '../../../shared/constants'

type Props = {
  show: boolean
  onHide: () => void
  onConfirm: (folderName: string) => void
  scheduler: SchedulerModel | null
}

const TrySchedulerModal: FC<Props> = ({show, onHide, onConfirm, scheduler}) => {
  const intl = useIntl()
  const [executeDate, setExecuteDate] = useState(moment())
  const [acknowledged, setAcknowledged] = useState(false)

  const handleConfirm = () => {
    onConfirm(executeDate.format('YYMMDD'))
    onHide()
    setAcknowledged(false)
  }

  const handleHide = () => {
    onHide()
    setAcknowledged(false)
  }

  if (!scheduler) return null

  return (
    <Modal show={show} onHide={handleHide} centered size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>{intl.formatMessage({id: 'Scheduler.TRY.TITLE'})}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='notice d-flex bg-light-info rounded border-info border border-dashed p-4 mb-5'>
          <i className='fas fa-info-circle text-info fs-3 me-3 mt-0'></i>
          <div className='fs-7 text-gray-700'>{intl.formatMessage({id: 'Scheduler.TRY.NOTE'})}</div>
        </div>
        <div className='row mb-3'>
          <div className='col-6'>
            <label className='form-label fw-bold'>
              {intl.formatMessage({id: 'Scheduler.TABLE.DESCRIPTION'})}
            </label>
            <p>{scheduler.name}</p>
          </div>
          <div className='col-6'>
            <label className='form-label fw-bold'>
              {intl.formatMessage({id: 'Scheduler.TABLE.FOLDER'})}
            </label>
            <p>{scheduler.folderType}</p>
          </div>
        </div>
        <div className='row mb-3'>
          <div className='col-6'>
            <label className='form-label fw-bold'>
              {intl.formatMessage({id: 'Scheduler.TABLE.FOLDERNAME'})}
            </label>
            <p>{scheduler.folderName}</p>
          </div>
          <div className='col-6'>
            <label className='form-label fw-bold'>
              {intl.formatMessage({id: 'Scheduler.TABLE.SETTING'})}
            </label>
            <p>{scheduler.setting}</p>
          </div>
        </div>

        <div className='mb-3'>
          <label className='form-label '>
            {intl.formatMessage({id: 'Scheduler.TRY.EXECUTE_DATE'})} :(
            {executeDate.format('YYMMDD')})
          </label>
          <input
            type='date'
            className='form-control'
            value={executeDate.format(DATE_FORMAT)}
            onChange={(e) => setExecuteDate(moment(e.target.value))}
          />
        </div>
        <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed p-5 mt-5'>
          <i className='fas fa-exclamation-triangle text-warning fs-3 me-3 mt-0'></i>
          <div className='fs-7 text-gray-700'>
            <p className='fw-bold mb-2'>
              {intl.formatMessage({id: 'Scheduler.TRY.WARNING_TITLE'})}
            </p>
            <ul className='mb-0 ps-4'>
              <li>{intl.formatMessage({id: 'Scheduler.TRY.WARNING_SINGLE_DATE'})}</li>
              <li>{intl.formatMessage({id: 'Scheduler.TRY.WARNING_RERUN_CHARGE'})}</li>
              <li>{intl.formatMessage({id: 'Scheduler.TRY.WARNING_NO_OVERRIDE'})}</li>
            </ul>
          </div>
        </div>
        <div className='form-check mt-5'>
          <input
            className='form-check-input'
            type='checkbox'
            id='acknowledgeCheckbox'
            checked={acknowledged}
            onChange={(e) => setAcknowledged(e.target.checked)}
          />
          <label className='form-check-label fs-7' htmlFor='acknowledgeCheckbox'>
            {intl.formatMessage({id: 'Scheduler.TRY.ACKNOWLEDGE'})}
          </label>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type='button' className='btn btn-light' onClick={handleHide}>
          {intl.formatMessage({id: 'GENERAL.CANCEL'})}
        </button>
        <button
          type='button'
          className='btn btn-primary'
          onClick={handleConfirm}
          disabled={!executeDate || !acknowledged}
        >
          {intl.formatMessage({id: 'Scheduler.TRY.CONFIRM'})}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default TrySchedulerModal
